import { ModelInfo, ModelInfoList, ModelProviders } from "../../types";

type ModelMap = {
  [key: string]: ModelInfo[];
};

export const groupModelsByProvider = (data: ModelInfoList | null): ModelProviders => {
  if (!data) {
    return {
      providers: [],
      defaultModelId: undefined,
    };
  }

  const providerMap = data.models.reduce((obj: ModelMap, model) => {
    obj[model.provider] ??= [];
    obj[model.provider].push({
      ...model,
    });
    return obj;
  }, {});

  return {
    providers: Object.entries(providerMap).map(([provider, models]) => ({
      providerName: provider,
      models,
    })),
    defaultModelId: data.defaultModelId,
  };
};
